import React from "react";
import { Icon } from "storefront/Icon";

type Props = Icon & {
  fill?: string;
};

const Warning = ({
  width = "24px",
  height = "20px",
  fill = "black",
  className,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.125 6.625H10.875L11.1562 12.625H12.8438L13.125 6.625Z"
      fill={fill}
    />
    <path d="M10.875 14.125H13.125V16.375H10.875V14.125Z" fill={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3752 1.75L2.50962 17.4353L3.05278 18.25H20.9472L21.4904 17.4353L12.6248 1.75H11.3752ZM13.5 0.25H10.5L0.75 17.5L2.25 19.75H21.75L23.25 17.5L13.5 0.25Z"
      fill={fill}
    />
  </svg>
);

export default Warning;
